<div class="flex-1 overflow-auto">
    <kui-card-header class="header d-flex align-items-center text-left p-3 overflow-hidden">
        <kui-card-title class="content-card-title card-title d-block">{{handler.title}}</kui-card-title>
        <ul class="content-card-actions">
        </ul>
    </kui-card-header>
    <div>
        <template #templateContainer></template>
    </div>
</div>